import { ROS2_API_RESTART_BANNER_TITLE } from '@sbrc/components/developer-api/legacyRosApiToggle';

import { ServiceRestartBanner } from './ServiceRestartBanner';
import { useControlSourceManagerRestartPending } from './useControlSourceManagerRestartPending';

/**
 * Shows the restart banner while botman still runs the previous ROS2 API
 * setting. Derived from robot state, so it follows the operator across pages
 * and clears on its own once botman has restarted.
 */
export function RosApiRestartBannerMount() {
  const isPending = useControlSourceManagerRestartPending();

  if (!isPending) {
    return null;
  }

  return (
    <ServiceRestartBanner
      title={ROS2_API_RESTART_BANNER_TITLE}
      service="botman"
    />
  );
}
